// Importa las librerías necesarias
import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/material';

// Define el componente de compartir
const Compartir = ({ nombre }) => {
    // URL base
    const baseUrl = 'https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/';

    // Reemplaza espacios con guiones en el nombre
    const nombreFormateado = nombre.split(' ').join('-');

    // URL completa
    const urlCompleta = `${baseUrl}${nombreFormateado}`;

    // Estado del menú
    const [anchorEl, setAnchorEl] = React.useState(null);

    // Abre el menú
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Cierra el menú
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            {/* Botón de compartir */}
            <Button startIcon={<ShareIcon />} onClick={handleClick} aria-controls="simple-menu" aria-haspopup="true">
                Compartir
            </Button>

            {/* Menú de opciones */}
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {/* Opción de enviar por WhatsApp */}
                <MenuItem onClick={handleClose}>
                    <a
                        href={`https://wa.me/?text=${encodeURIComponent(urlCompleta)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        WhatsApp
                    </a>
                </MenuItem>

                {/* Opción de enviar por correo */}
                <MenuItem onClick={handleClose}>
                    <a href={`mailto:?body=${encodeURIComponent(urlCompleta)}`}>Correo</a>
                </MenuItem>

                {/* Opción de compartir en Facebook */}
                <MenuItem onClick={handleClose}>
                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlCompleta)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Facebook
                    </a>
                </MenuItem>

                {/* Opción de copiar link */}
                <MenuItem onClick={handleClose}>
                    <Box onClick={() => navigator.clipboard.writeText(urlCompleta)}>
                        <span>Copiar enlace</span>
                    </Box>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default Compartir;